

(() => {
  let stop = () => {};
  const jumpToReviews = () => {
    stop();
    if (!/^#(?:mos-product-reviews|judgeme_product_reviews|MOSG?Reviews-)/.test(location.hash)) return;
    const target = document.getElementById('mos-product-reviews');
    if (!target) return;
    const controller = new AbortController();
    let frame;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    const observer = new ResizeObserver(align);
    observer.observe(target.closest('.mosr, .mosg') || target);
    const timer = setTimeout(() => stop(), 8000);
    stop = () => {
      controller.abort();
      observer.disconnect();
      clearTimeout(timer);
      cancelAnimationFrame(frame);
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => window.addEventListener(name, stop, { once: true, passive: true, signal: controller.signal }));
    window.addEventListener('load', align, { once: true, signal: controller.signal });
    align();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jumpToReviews, { once: true });
  else jumpToReviews();
  window.addEventListener('hashchange', jumpToReviews);
  window.addEventListener('pagehide', () => stop());
  document.addEventListener('shopify:section:load', jumpToReviews);
})();


/* MOS chronological Judge.me sort — 2026-10-06 */
(() => {
  const rootSelector = '#mos-product-reviews #judgeme_product_reviews';
  let observer;
  let frame = 0;

  const isRecentSort = (root) => {
    const select = root.querySelector('.jdgm-sort-dropdown, .jdgm-rev-widg__sort-wrapper select');
    if (!select) return true;
    const option = select.options && select.options[select.selectedIndex];
    const label = `${option ? option.textContent : ''} ${select.value || ''}`.trim().toLowerCase();
    if (!label) return true;
    return /(recent|newest|latest|meest recent|nieuwste|neueste|récent|reciente|recente|più recent|الأحدث|created[_ -]?at)/i.test(label);
  };

  const reviewTime = (review) => {
    const time = review.querySelector('time.jdgm-rev__timestamp[datetime]');
    if (!time) return 0;
    return Date.parse(time.getAttribute('datetime') || '') || 0;
  };

  const sortList = (list) => {
    const reviews = Array.from(list.children).filter((el) => el.matches('.jdgm-rev'));
    if (reviews.length < 2) return;
    const sorted = reviews.slice().sort((a, b) => reviewTime(b) - reviewTime(a));
    if (sorted.every((el, index) => el === reviews[index])) return;
    sorted.forEach((review) => list.appendChild(review));
  };

  const apply = () => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    root.querySelectorAll('.jdgm-medal[aria-label]').forEach((medal) => {
      const value = medal.querySelector('.jdgm-medal__value')?.textContent?.trim();
      const label = medal.getAttribute('aria-label') || '';
      if (value && !label.includes(value)) medal.setAttribute('aria-label', `${label} ${value}`.trim());
    });

    if (isRecentSort(root)) {
      root.querySelectorAll('.jdgm-rev-widg__reviews').forEach(sortList);
    }
  };

  const run = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (observer) observer.disconnect();
      apply();
      const root = document.querySelector(rootSelector);
      if (root && observer) observer.observe(root, { childList: true, subtree: true });
    });
  };

  const start = () => {
    if (observer) observer.disconnect();
    observer = new MutationObserver(run);
    const root = document.querySelector(rootSelector);
    if (root) observer.observe(root, { childList: true, subtree: true });
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('change', (event) => {
    if (event.target && event.target.matches('.jdgm-sort-dropdown, .jdgm-rev-widg__sort-wrapper select')) {
      setTimeout(run, 0);
    }
  });

  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pagehide', () => {
    if (observer) observer.disconnect();
    cancelAnimationFrame(frame);
  });
})();
